// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentClientIdentifiersModel {
    static getAttributeTypeMap() {
        return EnrollmentClientIdentifiersModel.attributeTypeMap;
    }
}
EnrollmentClientIdentifiersModel.discriminator = undefined;
EnrollmentClientIdentifiersModel.attributeTypeMap = [
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "string"
    },
    {
        "name": "alternateId",
        "baseName": "alternateId",
        "type": "string"
    },
    {
        "name": "alternateIdType",
        "baseName": "alternateIdType",
        "type": "string"
    }
];
//# sourceMappingURL=enrollmentClientIdentifiersModel.js.map